import React from "react";

const Base = () => {
  return (
    <div className="six wide column center aligned">
      <div style={{ marginTop: "35px" }}>
        <img
          className="ui medium circular image centered fixed"
          alt="my_image"
          src={require("../statics/me.png")}
        ></img>
        <h1 className="ui huge header">Saksham Manocha</h1>
        <h3
          className="ui header center"
          style={{
            letterSpacing: "1px",
            fontWeight: "bolder",
            fontFamily: "Arial",
          }}
        >
          Full Stack Developer && Machine Learning Enthusiast && Liverpool Fan
        </h3>
      </div>
      <div className="ui divider"></div>
    </div>
  );
};

export default Base;
